import { MandantModel } from '../../../../../../../../mandant/models/mandant.model';

export const findMandantPredicate =
  (activeMandantId: number | null): ((mandant: MandantModel) => boolean) =>
  (mandant: MandantModel): boolean =>
    mandant.id === activeMandantId;
